export function buildCommonUIProps(options) {
    const props = {};
    const dataUi = options.dataUi ?? options.defaultDataUi;
    if (dataUi !== undefined) {
        props['data-ui'] = dataUi;
    }
    if (options.style !== undefined) {
        props.style = options.style;
    }
    if (options.role) {
        props.role = options.role;
    }
    if (options.tabIndex !== undefined) {
        props.tabIndex = options.tabIndex;
    }
    if (options.ariaLabel) {
        props.ariaLabel = options.ariaLabel;
    }
    if (options.ariaLabelledBy !== undefined) {
        props.ariaLabelledBy = options.ariaLabelledBy;
    }
    if (options.ariaHidden !== undefined) {
        props['aria-hidden'] = options.ariaHidden;
    }
    if (options.ariaDescribedBy !== undefined) {
        props.ariaDescribedBy = options.ariaDescribedBy;
    }
    if (options.id) {
        props.id = options.id;
    }
    return props;
}
//# sourceMappingURL=common-props.js.map